import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// import required modules
import { EffectCoverflow, Pagination } from "swiper/modules";

export default function ChattingSwiperSlider() {
  return (
    <>
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <h2
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontFamily: "arial",
          }}
          className="Key-feature-heading"
        >
          Application Preview
        </h2>
      </div>

      <Swiper
        loop={true} // Enable infinite loop
        autoplay={{ delay: 3000 }} // Autoplay with 3-second delay
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-1.webp"
            alt="Chattingsliderpic-1"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-2.webp"
            alt="Chattingsliderpic-2"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-3.webp"
            alt="Chattingsliderpic-3"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-4.webp"
            alt="Chattingsliderpic-4"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-5.webp"
            alt="Chattingsliderpic-5"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            className="swiper-slider-images"
            src="./images/Chattingsliderpic-6.webp"
            alt="Chattingsliderpic-6"
          />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
